import { EmailNotifications } from "modules/emailNotifications";

const EmailNotificationsPage = () => {
  return <EmailNotifications />;
};

export default EmailNotificationsPage;
